module.exports = __webpack_public_path__ + "static/tax-documents-hero-mobile.715a57cd.webp";